export enum SupervisorsAssessmentBiometrics {
    good = 'good',
    moderate = 'moderate',
    poor = 'poor',
}
